import { render, staticRenderFns } from "./groupList.vue?vue&type=template&id=24ac8140&scoped=true"
import script from "./groupList.vue?vue&type=script&lang=js"
export * from "./groupList.vue?vue&type=script&lang=js"
import style0 from "./groupList.vue?vue&type=style&index=0&id=24ac8140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac8140",
  null
  
)

export default component.exports